import { useState, useEffect } from "react";
import { Menu, X, Phone } from "lucide-react";

const links = [
  { label: "Specialties", href: "#specialties" },
  { label: "The Garage", href: "#garage" },
  { label: "Visit Us", href: "#visit" },
  { label: "Inquire", href: "#inquiry" },
];

export const Navbar = () => {
  const [scrolled, setScrolled] = useState(false);
  const [open, setOpen] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 40);
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <nav
      data-testid="navbar"
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        scrolled ? "bg-[#0A0A0A]/95 backdrop-blur-md border-b border-[#262626]" : "bg-transparent"
      }`}
    >
      <div className="max-w-7xl mx-auto px-6 lg:px-8 flex items-center justify-between h-20">
        <a href="#hero" data-testid="nav-logo" className="font-heading text-xl lg:text-2xl font-bold uppercase tracking-tight text-white">
          Jatt Car <span className="text-[#FF4500]">Modification</span>
        </a>
        <div className="hidden md:flex items-center gap-10">
          {links.map((l) => (
            <a
              key={l.href}
              href={l.href}
              data-testid={`nav-link-${l.label.toLowerCase().replace(/\s/g, "-")}`}
              className="text-sm uppercase tracking-widest text-neutral-400 hover:text-[#FF4500] transition-colors duration-200"
            >
              {l.label}
            </a>
          ))}
          <a
            href="tel:2046196003"
            data-testid="nav-phone-btn"
            className="flex items-center gap-2 bg-[#FF4500] text-white text-sm font-bold uppercase tracking-wider py-2.5 px-5 border border-[#FF4500] hover:bg-transparent hover:text-[#FF4500] transition-all duration-300"
          >
            <Phone size={15} /> 204-619-6003
          </a>
        </div>
        <button
          data-testid="nav-mobile-toggle"
          className="md:hidden text-white"
          onClick={() => setOpen(!open)}
          aria-label="Toggle menu"
        >
          {open ? <X size={26} /> : <Menu size={26} />}
        </button>
      </div>
      {open && (
        <div data-testid="nav-mobile-menu" className="md:hidden bg-[#0A0A0A] border-t border-[#262626] px-6 py-6 flex flex-col gap-5">
          {links.map((l) => (
            <a
              key={l.href}
              href={l.href}
              onClick={() => setOpen(false)}
              className="text-sm uppercase tracking-widest text-neutral-300 hover:text-[#FF4500]"
            >
              {l.label}
            </a>
          ))}
          <a href="tel:2046196003" className="flex items-center gap-2 text-[#FF4500] font-bold uppercase text-sm tracking-wider">
            <Phone size={15} /> 204-619-6003
          </a>
        </div>
      )}
    </nav>
  );
};
